import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  EducationFacade,
  JobsFacade,
  ProjectsFacade,
} from '@dges/modules/portfolio/store/ngrx';
import {
  ENTITY_FACADE,
  EntityFacade,
} from '@dges/pattern/entity-list';
import { Education, Job, Project } from '@dges/modules/portfolio/domain';

const projectsEntityFacade = {
  provide: ENTITY_FACADE,
  useFactory: (f: ProjectsFacade): EntityFacade<Project> => ({
    loaded$: f.loaded$,
    allEntities$: f.allItems$,
    selectedEntity$: f.selectedItem$,
    load: () => f.load(),
    editEntity: (p) => f.editItem(p),
    deleteEntity: (p) => f.deleteItem(p),
  }),
  deps: [ProjectsFacade],
};

const jobsEntityFacade = {
  provide: ENTITY_FACADE,
  useFactory: (f: JobsFacade): EntityFacade<Job> => ({
    loaded$: f.loaded$,
    allEntities$: f.allItems$,
    selectedEntity$: f.selectedItem$,
    load: () => f.load(),
    editEntity: (j) => f.editItem(j),
    deleteEntity: (j) => f.deleteItem(j),
  }),
  deps: [JobsFacade],
};

const educationsEntityFacade = {
  provide: ENTITY_FACADE,
  useFactory: (f: EducationFacade): EntityFacade<Education> => ({
    loaded$: f.loaded$,
    allEntities$: f.allItems$,
    selectedEntity$: f.selectedItem$,
    load: () => f.load(),
    editEntity: (e) => f.editItem(e),
    deleteEntity: (e) => f.deleteItem(e),
  }),
  deps: [EducationFacade],
};

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'timeline' },
  {
    path: 'projects',
    providers: [projectsEntityFacade],
    loadChildren: () =>
      import('@dges/modules/portfolio/featureRead').then((m) => m.projectsRoutes),
  },
  {
    path: 'jobs',
    providers: [jobsEntityFacade],
    loadChildren: () =>
      import('@dges/modules/portfolio/featureRead').then((m) => m.jobsRoutes),
  },
  {
    path: 'educations',
    providers: [educationsEntityFacade],
    loadChildren: () =>
      import('@dges/modules/portfolio/featureRead').then((m) => m.educationsRoutes),
  },
  {
    path: 'timeline',
    loadComponent: () =>
      import('@dges/modules/portfolio/featureRead').then((m) => m.TimelinePageComponent),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
